import * as React from "react";
const Twitter = (props) => (
  <svg
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-[48px] h-[48px] lg:w-[56px] lg:h-[56px] ${props.customClasses}`}
  >
    <circle
      cx="28"
      cy="28"
      r="27.5"
      stroke="#1F2022"
      className="group-hover:fill-primary"
    />
    <path
      d="m19.047 18 7.494 10.482L19 37h1.697l6.603-7.459 5.336 7.46h5.775l-7.916-11.07L37.515 18h-1.698l-6.08 6.869L24.822 18h-5.776Zm2.497 1.308h2.653l11.716 16.385h-2.652L21.543 19.308Z"
      fill="#1F2022"
      className="group-hover:fill-white"
    />
  </svg>
);
export default Twitter;
